module.exports = __webpack_public_path__ + "static/media/securite.abd88bfe.png";